import axios from 'axios'
import { AbstractService } from "./abstract.service";
import { AuthService } from "@/services/auth.service";
import $store from "@/state/store"

export class RoleService extends AbstractService {
  static get entityRole() {
    return "np-iam-roles";
  }

  static get entityPermission() {
    return "np-iam-permissions";
    //return "api/permission";
  }

  static get entityRoleforUser() {
    return "np-iam-user-roles";
    //return "api/permission";
  }

  static get URL_GATEWAY_ROLE() {
    return process.env.VUE_APP_ROLE_URL;
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }
  //Role
  static async getListRole(params) {
      try {
          const response = await axios.get(
              `${this.URL_GATEWAY_ROLE}/${this.entityRole}/list?merchantId=${params.merchantId}&appId=${process.env.VUE_APP_ID}&page=${params.page}&limit=${params.limit}`,
          )
          return response.data
      } catch (error) {
          console.log(error);
      }
  }

  static async getListRoleByRoleName(params) {
    try {
      const response = await this.callApi().post(
          `${this.URL_GATEWAY}/iam/roles/search`,params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getItemRole(params) {
    try {
        const response = await axios.get(
            `${this.URL_GATEWAY_ROLE}/${this.entityRole}/${params.roleId}/permissions?lang=${params.lang}`,
        )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async updateItemRole(params) {
    try {
        const response = await axios.post(
            `${this.URL_GATEWAY_ROLE}/${this.entityRole}/update`, params)
        return response.data
    } catch (error) {
        console.log(error);
    }
  }

  static async createItemRole(params) {
    try {
        const response = await axios.post(
            `${this.URL_GATEWAY_ROLE}/${this.entityRole}/create`, params)
        return response.data
    } catch (error) {
        console.log(error);
    }
}

  static async deleteItemRole(params) {
      try {
          const response = await axios.post(
            `${this.URL_GATEWAY_ROLE}/${this.entityRole}/delete`,
             params
          )
          return response.data
      } catch (error) {
          console.log(error);
      }
  }

  //Permisions
  static async getPermissionsApp(params) {
    try {
        const response = await axios.get(
            `${this.URL_GATEWAY_ROLE}/${this.entityPermission}/list?&appId=${process.env.VUE_APP_ID}&lang=${params.lang}&page=${params.page}&limit=${params.limit}`,
        )
        return response.data
    } catch (error) {
        console.log(error);
    }
  }

  static async initPermissions(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY_ROLE}/${this.entityPermission}/init`,
        params
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async deletePermissions(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY_ROLE}/${this.entityPermission}/delete`,
        params
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getListPermissionsUser() {
    try {
      const inforAccount = JSON.parse(localStorage.getItem("auth.currentUser"))
      if(inforAccount !== null) {
        /*
        const locationIdOne = (inforAccount.locationInfos[0].id) ? inforAccount.locationInfos[0].id : ""
        const locationIdTwo = JSON.stringify(localStorage.getItem("LID"))
        const locationId = (locationIdTwo !== null) ? locationIdTwo : locationIdOne
        */
      const params = {
        "appId": process.env.VUE_APP_ID,
        "locationId": inforAccount.role == "owner" ? null : $store.state.auth.currentLocation,
        "merchantId": (inforAccount.merchantId) ? inforAccount.merchantId : "",
        "userId": (inforAccount.userId) ? inforAccount.userId : ""
      }
          
      const response = await axios.post(`${this.URL_GATEWAY_ROLE}/${this.entityPermission}/get`, params)
        if (response.data.success) {
          const permissions = (response.data.data.permissions) ? response.data.data.permissions : []
          localStorage.setItem('dataPermission', JSON.stringify(permissions))
        }
        return response.data
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Role for User
  static async assignRoleForUser(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY_ROLE}/${this.entityRoleforUser}/mapping`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }
}
